import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as QuestionMark } from '../../../images/question-icon.svg';
import RichTextConverter from '../RichText/RichTextConverter';
import * as styles from './Calculation.module.scss';
import * as tooltipStyles from './TooltipStyles.module.scss';

export default function Calculation({ revenue, tooltips, version }) {
  const increaseTooltip = tooltips?.find((tooltip) => tooltip.subtitle === 'increase')?.body;
  const lossTooltip = tooltips?.find((tooltip) => tooltip.subtitle === 'loss')?.body;

  return (
    <div className={[styles.impact, styles[version]].join(' ')}>
      <div className={styles.original}>
        <span>Starting Revenue</span>
        <span className={styles.result}>{revenue.original}</span>
      </div>
      <div className={styles.columns}>
        <div>
          <span data-tooltip-id={`tt-increase`}>
            Increase{' '}
            {increaseTooltip && (
              <QuestionMark className={[tooltipStyles.tooltipIcon, `increase-tooltip-icon`].join(' ')} />
            )}
          </span>
          {increaseTooltip && (
            <Tooltip
              id={`tt-increase`}
              anchorSelect={`.increase-tooltip-icon`}
              className={tooltipStyles.tooltip}
              classNameArrow={tooltipStyles.tooltipArrow}
              content={<RichTextConverter copy={increaseTooltip} />}
            />
          )}
          <span className={styles.result}>{revenue.increase}</span>
        </div>
        <div>
          <span data-tooltip-id={`tt-loss`}>
            Experience Loss
            {lossTooltip && <QuestionMark className={[tooltipStyles.tooltipIcon, `loss-tooltip-icon`].join(' ')} />}
          </span>
          {lossTooltip && (
            <Tooltip
              id={`tt-loss`}
              anchorSelect={`.loss-tooltip-icon`}
              className={tooltipStyles.tooltip}
              classNameArrow={tooltipStyles.tooltipArrow}
              content={<RichTextConverter copy={lossTooltip} />}
            />
          )}
          <span className={styles.result}>
            {revenue.loss !== '$0' && '-'}
            {revenue.loss}
          </span>
        </div>
      </div>
    </div>
  );
}
